exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-loader[data-v-c2440f40]{display:flex;align-items:center;justify-content:center;height:100%;width:100%}", ""]);

// exports
